// extracted by mini-css-extract-plugin
export default {"ai-configuration-form":"kdwXrlnC94eJFRYo7JNW","section-container":"JYS4_hVEhqgtDJE0xmW9","checkbox-label":"Q8NAseb9QRnVBAnSit8N","form-checkbox":"ALW2E49JrxxZFoNMqpdR"};